"use client";

import React from "react";
import { ArrowDownRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
export default function Missions() {
  const shouldReduceMotion = useReducedMotion();
  const handleScrollDown = () => {
    const nextSection = document.getElementById("heromisiones")?.nextElementSibling;
    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: "smooth"
      });
    } else {
      window.scrollBy({
        top: window.innerHeight * 0.8,
        behavior: "smooth"
      });
    }
  };
  return <section id="heromisiones" data-nav="dark" className="relative w-full min-h-[70vh] sm:min-h-[80vh] md:min-h-[90vh] flex items-end overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 w-full h-full">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/missions_hero_prayer.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/missions_hero_prayer.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/missions_hero_prayer.png-wvc-sizes" alt="Hands placed in prayer during missions ministry" loading="eager" decoding="async" className="w-full h-full object-cover object-center !opacity-[0.66] !bg-[rgba(0,0,0,0.98)]" />
        {}
        <div className="w-full h-full object-cover object-center !opacity-[0.66] !bg-[rgba(0,0,0,0.98)] !text-[rgba(244,246,250,1)]" />
      </div>

      {}
      <div className="relative z-10 w-full px-6 sm:px-12 md:px-16 lg:px-24 pb-12 sm:pb-16 md:pb-20">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
          <motion.div initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: "easeOut"
        }} className="max-w-2xl">
            <h1 className="text-4xl font-default tracking-tight uppercase drop-shadow-sm !font-normal !text-[rgba(29,40,58,1)] sm:text-6xl md:text-7xl lg:text-8xl">
              MISIONES
            </h1>
          </motion.div>

          <motion.div initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2,
          ease: "easeOut"
        }} className="self-end">
            <Button onClick={handleScrollDown} size="icon" variant="default" aria-label="Scroll to missions details" className="size-14 sm:size-16 rounded-full bg-white text-slate-900 hover:bg-white/90 shadow-lg transition-[transform,background-color] hover:scale-105 active:scale-95 cursor-pointer">
              <ArrowDownRight className="size-6 sm:size-7 stroke-[2.5]" />
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}